module.exports = __webpack_public_path__ + "media/images/talent/case2-icon01-86947838fd1cb221e06ed23c6f690fed.png";